import React from 'react';
import {
  ShieldCheckIcon,
  CreditCardIcon,
  BanknotesIcon,
} from '@heroicons/react/24/outline';

const SecurityBadges = () => {
  return (
    <div className='flex justify-center space-x-8 mb-12'>
      <div className='text-center'>
        <div className='inline-flex items-center justify-center w-12 h-12 bg-slate-100 rounded-lg mb-3'>
          <ShieldCheckIcon className='w-6 h-6 text-blue-600' />
        </div>
        <p className='text-sm font-medium text-slate-600'>Pago Seguro</p>
      </div>
      <div className='text-center'>
        <div className='inline-flex items-center justify-center w-12 h-12 bg-slate-100 rounded-lg mb-3'>
          <BanknotesIcon className='w-6 h-6 text-blue-600' />
        </div>
        <p className='text-sm font-medium text-slate-600'>Transacción Verificada</p>
      </div>
      <div className='text-center'>
        <div className='inline-flex items-center justify-center w-12 h-12 bg-slate-100 rounded-lg mb-3'>
          <CreditCardIcon className='w-6 h-6 text-blue-600' />
        </div>
        <p className='text-sm font-medium text-slate-600'>Datos Protegidos</p>
      </div>
    </div>
  );
};

export default SecurityBadges;
